import { AuthConfig } from 'angular-oauth2-oidc';
//import { environment } from '@environments/environment';
export const authImplicitFlowConfig: AuthConfig = {

  // Url of the Identity Provider
  loginUrl: '/oauth/authorize',
  redirectUri: window.location.origin + '/index.html',
  userinfoEndpoint: '/service-profile/api/v1.0/profiles',
  clientId: 'clientId',
  dummyClientSecret: 'secret',
  scope: 'read write',
  showDebugInformation: true,
  requireHttps: false,
  logoutUrl: window.location.origin + '/logout',
  silentRefreshRedirectUri: window.location.origin + '/silent-refresh.html',
  oidc: false,
  tokenEndpoint: '/oauth2/oauth/token',
  useHttpBasicAuth: true,
  sessionChecksEnabled: false,

}
